/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FeatureCollection } from "geojson";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

interface ObterZonasGeoRequest {
  onSuccess?: (result: FeatureCollection) => void;
}

interface State {
  isRequesting: boolean;
  // Muda a cada resposta. O <GeoJSON> do react-leaflet ignora troca de `data`
  // depois de montado, então a camada é remontada por `key`.
  requestNumber: string;
  successPayload: FeatureCollection | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  requestNumber: String(Math.random()),
  successPayload: null,
  errors: []
};

const obterZonasGeoSlice = createSlice({
  name: "consultaprevia@obterZonasGeo",
  initialState,
  reducers: {
    obterZonasGeo: (
      state,
      action: PayloadAction<ObterZonasGeoRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterZonasGeoSuccess: (
      state,
      action: PayloadAction<FeatureCollection>
    ): void => {
      state.requestNumber = String(Math.random());
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterZonasGeoFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: ObterZonasGeoRequest;
}) {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/consulta-previa/zonas/geo`
    );

    const { data }: { data: FeatureCollection } = response;

    if (params.payload?.onSuccess) params.payload.onSuccess(data);

    yield put(obterZonasGeoSuccess(data));
  } catch (error) {
    yield put(obterZonasGeoFailed(formatError(error)));
  }
}

export const { obterZonasGeo, obterZonasGeoSuccess, obterZonasGeoFailed } =
  obterZonasGeoSlice.actions;
export const { reducer } = obterZonasGeoSlice;
export const saga = takeLatest(obterZonasGeo.type, sagaFunction);
